import React from 'react';
import { useScreen } from '../lib/useScreen';
import { useAuth } from '../lib/AuthProvider';
import { startCheckout } from '../lib/checkout';
import { supabase } from '../lib/supabaseClient';
// import { FORMS_31, CATEGORIES } from '../lib/tuRadarData'; // Removed — no spoilers on landing

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', morado:'#534AB7', verde:'#1D9E75', dark:'#0a0a0a' };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const glass = { background:'rgba(255,255,255,0.05)', backdropFilter:'blur(30px)', WebkitBackdropFilter:'blur(30px)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:20 };

export default function TuRadarLanding() {
  const { isMobile } = useScreen();
  const { user, profile } = useAuth();

  const handleBuy = () => {
    if (!user) {
      localStorage.setItem('td_pending_checkout', 'tu_radar');
      supabase.auth.signInWithOAuth({ provider:'google', options:{ redirectTo: window.location.origin + '/dashboard' } });
      return;
    }
    startCheckout('tu_radar', user, profile);
  };

  const phases = [
    { week:'Semana 1', title:'Conócete', emoji:'🔍', color:C.morado, desc:'Test de descubrimiento D1 + explora las 8 categorías de negocio digital. Descubre dónde están tus fortalezas.' },
    { week:'Semanas 2-3', title:'Explora las 31 formas', emoji:'🗺️', color:C.turquesa, desc:'Cada día profundizas en 2 formas reales de ganar dinero en internet. Ejercicios prácticos incluidos.' },
    { week:'Semana 4', title:'Tu decisión', emoji:'🎯', color:C.mango, desc:'Reduce a tu top 5, luego top 3, luego UNA. Con Genio & Luca te ayudamos a elegir con claridad.' },
  ];

  const forWhom = [
    'Sueñas con generar ingresos por internet pero no sabes por dónde empezar',
    'Ves gente viajando y trabajando desde su laptop y quieres eso',
    'Tienes muchas ideas pero ninguna concreta',
    'Quieres algo propio pero no sabes qué es "lo tuyo"',
    'Necesitas claridad, no otro curso de "cómo hacerte rico"',
  ];

  return (
    <div style={{ fontFamily:font, color:'#fff', background:C.dark, minHeight:'100vh' }}>
      {/* HERO */}
      <section style={{ maxWidth:800, margin:'0 auto', padding:isMobile?'3rem 1rem':'5rem 1.5rem', textAlign:'center' }}>
        <p style={{ fontSize:12, color:C.mango, fontWeight:500, letterSpacing:2, margin:'0 0 14px' }}>TU RADAR</p>
        <h1 style={{ fontFamily:serif, fontSize:isMobile?28:48, fontWeight:400, margin:'0 0 16px', lineHeight:1.15 }}>
          31 caminos. 30 días para explorarlos.<br/>
          <span style={{ color:C.turquesa }}>1 que será el tuyo.</span>
        </h1>
        <p style={{ fontSize:isMobile?15:18, color:'rgba(255,255,255,0.6)', lineHeight:1.7, maxWidth:560, margin:'0 auto 12px' }}>
          No te decimos qué emprender. Te mostramos las 31 formas reales de ganar dinero en internet y te ayudamos a descubrir cuál es para ti.
        </p>
        <div style={{ display:'flex', alignItems:'baseline', justifyContent:'center', gap:6, margin:'24px 0' }}>
          <span style={{ fontSize:isMobile?36:48, fontWeight:600, background:'linear-gradient(135deg, #534AB7, #1D9E75)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text' }}>$599 MXN</span>
          <span style={{ fontSize:14, color:'rgba(255,255,255,0.4)' }}>pago único · acceso de por vida</span>
        </div>
        <button onClick={handleBuy} style={{ background:'linear-gradient(135deg, #534AB7, #1D9E75)', color:'#fff', border:'none', borderRadius:50, padding:isMobile?'16px 36px':'18px 48px', fontSize:isMobile?16:18, fontWeight:500, cursor:'pointer', fontFamily:font, boxShadow:'0 0 40px rgba(93,193,185,0.3)' }}>
          Quiero mi Radar →
        </button>
        <p style={{ fontSize:11, color:'rgba(255,255,255,0.3)', margin:'12px 0 0' }}>Garantía de reembolso 14 días. Sin preguntas.</p>
        <p style={{ fontSize:10, color:'rgba(255,255,255,0.25)', margin:'6px 0 0' }}>Al comprar aceptas nuestros <a href="/terminos" style={{ color:'rgba(255,255,255,0.4)', textDecoration:'underline' }}>Términos</a> y <a href="/privacidad" style={{ color:'rgba(255,255,255,0.4)', textDecoration:'underline' }}>Aviso de privacidad</a>.</p>
      </section>

      {/* 3 FASES */}
      <section style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem' }}>
        <p style={{ fontSize:12, color:C.turquesa, fontWeight:500, letterSpacing:2, textAlign:'center', margin:'0 0 8px' }}>CÓMO FUNCIONA</p>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:30, textAlign:'center', margin:'0 0 32px' }}>30 días, 3 fases</p>
        <div style={{ display:'flex', flexDirection:isMobile?'column':'row', gap:16 }}>
          {phases.map((p, i) => (
            <div key={i} style={{ ...glass, flex:1, padding:'24px 20px', borderTop:`3px solid ${p.color}` }}>
              <p style={{ fontSize:11, color:p.color, fontWeight:500, letterSpacing:1, margin:'0 0 8px' }}>{p.week}</p>
              <p style={{ fontSize:32, margin:'0 0 8px' }}>{p.emoji}</p>
              <p style={{ fontSize:18, fontWeight:500, margin:'0 0 8px' }}>{p.title}</p>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:0 }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* LAS 31 FORMAS PREVIEW */}
      <section style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem' }}>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:28, textAlign:'center', margin:'0 0 8px' }}>31 caminos reales</p>
        <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', textAlign:'center', margin:'0 0 28px', maxWidth:500, marginLeft:'auto', marginRight:'auto', lineHeight:1.7 }}>31 formas reales de generar ingresos en internet desde LatAm. Las descubrirás durante el curso, una por una, con casos reales y datos verificados.</p>
        <div style={{ display:'flex', gap:isMobile?12:24, justifyContent:'center' }}>
          {[{ n:'31', label:'caminos' },{ n:'30', label:'días' },{ n:'1', label:'decisión clara' }].map((s,i) => (
            <div key={i} style={{ ...glass, padding:isMobile?'20px 16px':'24px 28px', textAlign:'center', flex:1, maxWidth:160 }}>
              <p style={{ fontSize:isMobile?28:36, fontWeight:600, margin:'0 0 4px', background:'linear-gradient(135deg, #534AB7, #1D9E75)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text' }}>{s.n}</p>
              <p style={{ fontSize:12, color:'rgba(255,255,255,0.5)', margin:0 }}>{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PARA QUIÉN ES */}
      <section style={{ maxWidth:600, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem' }}>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:28, textAlign:'center', margin:'0 0 24px' }}>¿Es para ti?</p>
        <div style={{ ...glass, padding:'24px 20px' }}>
          {forWhom.map((item, i) => (
            <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:i < forWhom.length - 1 ? 16 : 0 }}>
              <span style={{ color:C.turquesa, fontWeight:700, fontSize:16, flexShrink:0, marginTop:1 }}>✓</span>
              <p style={{ fontSize:14, color:'rgba(255,255,255,0.7)', lineHeight:1.6, margin:0 }}>{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 5 VIDEOS */}
      <section style={{ maxWidth:600, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem', textAlign:'center' }}>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:28, margin:'0 0 8px' }}>5 videos exclusivos</p>
        <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', margin:'0 0 24px' }}>Bruno te acompaña personalmente en cada etapa del proceso</p>
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {['🎬 Bienvenida a Tu Radar', '🗺️ Inicio Sem 2: Explora', '🔍 Inicio Sem 3: Profundiza', '🎯 Inicio Sem 4: Decide', '🎉 Cierre: Tu camino empieza'].map((v, i) => (
            <div key={i} style={{ ...glass, padding:'14px 18px', display:'flex', alignItems:'center', gap:10, textAlign:'left' }}>
              <span style={{ fontSize:20 }}>▶</span>
              <p style={{ fontSize:14, margin:0 }}>{v}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ maxWidth:600, margin:'0 auto', padding:isMobile?'2rem 1rem':'4rem 1.5rem', textAlign:'center' }}>
        <div style={{ ...glass, padding:isMobile?'2rem 1.5rem':'3rem', borderTop:`3px solid ${C.mango}` }}>
          <p style={{ fontFamily:serif, fontSize:isMobile?24:32, margin:'0 0 8px' }}>¿Listo para encontrar tu camino?</p>
          <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', margin:'0 0 24px', lineHeight:1.6 }}>
            30 días. 31 formas. 1 decisión. Y entras a la red de emprendedores T&D para siempre.
          </p>
          <div style={{ display:'flex', alignItems:'baseline', justifyContent:'center', gap:6, margin:'0 0 20px' }}>
            <span style={{ fontSize:36, fontWeight:600, color:'#fff' }}>$599 MXN</span>
            <span style={{ fontSize:13, color:'rgba(255,255,255,0.4)' }}>pago único</span>
          </div>
          <button onClick={handleBuy} style={{ background:'linear-gradient(135deg, #534AB7, #1D9E75)', color:'#fff', border:'none', borderRadius:50, padding:'16px 44px', fontSize:17, fontWeight:500, cursor:'pointer', fontFamily:font, boxShadow:'0 0 40px rgba(93,193,185,0.3)', marginBottom:12 }}>
            Quiero mi Radar →
          </button>
          <p style={{ fontSize:12, color:'rgba(255,255,255,0.4)', margin:0 }}>
            🛡️ Garantía de reembolso 14 días. Si no te convence, te devolvemos el 100%. Sin preguntas.
          </p>
          <p style={{ fontSize:10, color:'rgba(255,255,255,0.25)', margin:'6px 0 0' }}>Al comprar aceptas nuestros <a href="/terminos" style={{ color:'rgba(255,255,255,0.4)', textDecoration:'underline' }}>Términos</a> y <a href="/privacidad" style={{ color:'rgba(255,255,255,0.4)', textDecoration:'underline' }}>Aviso de privacidad</a>.</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ maxWidth:600, margin:'0 auto', padding:'2rem 1.5rem', textAlign:'center', borderTop:'1px solid rgba(255,255,255,0.08)' }}>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.3)', margin:'0 0 10px' }}>© 2026 Thinker & Doer · Tu Radar</p>
        <div style={{ display:'flex', justifyContent:'center', gap:16 }}>
          <a href="/terminos" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Términos</a>
          <a href="/privacidad" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Privacidad</a>
        </div>
      </footer>
    </div>
  );
}
